module.exports = __webpack_public_path__ + "static/media/not_found_error.79ecdae3.png";